import { cn } from "@ds/lib/utils";

/**
 * Skeleton — Capture Sheet field 12.14.
 *
 * Sized to the content it replaces and placed INSIDE the real frame, so nothing
 * moves when the data lands. Labels stay visible; only values are skeletonised.
 */
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden
      className={cn("animate-pulse rounded-pill bg-muted-foreground/15", className)}
      {...props}
    />
  );
}

export { Skeleton };
